import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Reward } from "./pages/Reward";
import { CustomerEdit } from "./pages/CustomerEdit";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { History } from "./pages/History";
import { Home } from "./pages/Home";
import { ManualTopup } from "./pages/ManualTopup";
import { Map } from "./pages/Map";
import { Scan } from "./pages/Scan";
import { Flyer } from "./pages/Flyer";
import { MapDetail } from "./pages/MapDetail";
import { Terms } from "./pages/Terms";
import { Rally } from "./pages/Rally";
import { RallyDetail } from "./pages/RallyDetail";
import { NoticeProvider } from "./context/NoticeContext";
import { CustomerInfoProvider } from "./context/CustomerInfoContext";

export const App = () => {
  return (
    <CustomerInfoProvider>
      <NoticeProvider>
        <BrowserRouter>
          <div className="app">
            <Header />
            <Routes>
              <Route path="*" element={<Home />} />
              <Route path="/scan" element={<Scan />} />
              <Route path="/map">
                <Route index={true} element={<Map />} />
                <Route path="/map/:issuerId" element={<MapDetail />} />
              </Route>
              <Route path="/flyer" element={<Flyer />} />
              <Route path="/reward" element={<Reward />} />
              <Route path="/history" element={<History />} />
              <Route path="/manual-topup" element={<ManualTopup />} />
              <Route path="/customer-edit" element={<CustomerEdit />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/rally">
                <Route index={true} element={<Rally />} />
                <Route path="/rally/:rallyId" element={<RallyDetail />} />
              </Route>
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </NoticeProvider>
    </CustomerInfoProvider>
  );
};
